module.exports = __webpack_public_path__ + "media/images/icons/filled/robot-caa78378cf925fde5ba4b67103e88f67.svg";